export const Blog = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 0.166016H1.75C0.7875 0.166016 0 0.953516 0 1.91602V11.8327H8.70917L7.5425 10.666H1.16667V4.24935H12.8333V7.70852L14 8.87518V1.91602C14 0.953516 13.2125 0.166016 12.25 0.166016ZM1.16667 3.08268V1.91602C1.16667 1.59518 1.42917 1.33268 1.75 1.33268H12.25C12.5708 1.33268 12.8333 1.59518 12.8333 1.91602V3.08268H1.16667ZM8.89 5.41602H6.41667V7.88935L11.0133 12.486C11.3458 12.8185 11.7833 12.9993 12.25 12.9993C12.7167 12.9993 13.1542 12.8185 13.4867 12.486C13.8192 12.1535 14 11.716 14 11.2493C14 10.7827 13.8192 10.3452 13.4867 10.0127L8.89 5.41602ZM12.6583 11.6635C12.4367 11.8852 12.0517 11.8852 11.8358 11.6635L7.58333 7.41102V6.58852H8.40583L12.6583 10.841C12.7692 10.9518 12.8275 11.0977 12.8275 11.2552C12.8275 11.4127 12.7692 11.5585 12.6583 11.6693V11.6635Z"
      fill="currentColor"
    />
  </svg>
);
